
import { currentHostWithProtocol } from 'bits/location'
import { Component, Prop, Vue } from 'bits/vue'
import rainbowLogo from 'images/padlet_logo_rainbow.png'
import uniqueId from 'lodash.uniqueid'

export enum LogoType {
  SingleColor = 'SingleColor',
  Rainbow = 'Rainbow',
  Light300 = 'Light300',
  Dark300 = 'Dark300',
  Light200 = 'Light200',
  Dark200 = 'Dark200',
  Light100 = 'Light100',
  Dark100 = 'Dark100',
}

@Component({})
export default class PadletLogo extends Vue {
  @Prop({ default: false }) darkMode!: boolean
  @Prop({ required: false }) href!: string
  @Prop({ default: LogoType.SingleColor }) type?: LogoType

  maskId = uniqueId('mask-')
  clipPathId = uniqueId('clippath-')

  currentHostWithProtocol = currentHostWithProtocol
  LogoType = LogoType
  rainbowLogo = rainbowLogo
}
